import { color } from 'd3-color';
import { interpolateRgb } from 'd3-interpolate';
import React, { Component } from 'react';
import LiquidFillGauge from 'react-liquid-gauge';

//Import styling
import '../../styles/Widget.css';
 
export default class LiquidGauge extends Component {
    state = {
        value: 100,
        boxShadow: null
    };
    startColor = '#1C3A4E'; // TopBar Color
    endColor = '#2196F3'; 
 
    render() {
        const radius = 80;
        const interpolate = interpolateRgb(this.startColor, this.endColor);
        const fillColor = interpolate(this.state.value / 100);
        const gradientStops = [
            {
                key: '0%',
                stopColor: color(fillColor).darker(0.5).toString(),
                stopOpacity: 1,
                offset: '0%'
            },
            {
                key: '50%',
                stopColor: fillColor,
                stopOpacity: 0.75,
                offset: '50%'
            },
            {
                key: '100%',
                stopColor: color(fillColor).brighter(0.5).toString(),
                stopOpacity: 0.5,
                offset: '100%'
            }
        ];
 
        return (
            <div>
                <LiquidFillGauge
                    style={{ borderRadius: '50%', margin: '5px auto', boxShadow: this.state.boxShadow}}
                    width={radius * 3}
                    height={radius * 3}
                    value={this.props.value}
                    percent="%"
                    textSize={1}
                    textOffsetX={7}
                    textOffsetY={22}
                    textRenderer={(props) => {
                        //const value = props.value;
                        const radius = Math.min(props.height / 2, props.width / 2);
                        const textPixels = (props.textSize * radius / 2);
                        const valueStyle = {
                            fontSize: textPixels,
                            opacity: .9
                        };
                        const percentStyle = {
                            fontSize: textPixels * 0.4,
                            opacity: .9
                        };
 
                        return (
                            <tspan>                     {/*FIXED random numbers at liquid gauge load*/}
                                <tspan className="liquid" style={valueStyle}>{this.props.value}</tspan>
                                <tspan className="liquid" style={percentStyle}>{props.percent}</tspan>
                            </tspan>
                        );
                    }}
                    riseAnimation = {true}
                    waveAnimation
                    waveFrequency={2}
                    waveAmplitude={2}
                    gradient
                    gradientStops={gradientStops}
                    
                    circleStyle={{
                        fill: fillColor
                    }}
                    waveStyle={{
                        fill: fillColor
                    }}
                    textStyle={{
                        fill: color('#ebebeb').toString(),
                        fontFamily: 'Arial'
                    }}
                    waveTextStyle={{
                        fill: color('#fff').toString(),
                        fontFamily: 'Arial'
                    }}
                    onClick={() => {
                        if(this.state.boxShadow === null){
                            this.setState({ boxShadow: 'inset 0 0 0px #2196F1, inset 0px 0 20px #2196f3, inset 0px 0 6px #2196f3, inset 0px 0 400px #122d42, inset 0px 0 150px #2196F3, 0 0 5px #2196f3, 0px 0 40px #2196f3, 0px 0 0px #2196f3' });
                        } else {                            
                            this.setState({ boxShadow: null });
                        }
                    }}
                />
            </div>
        );
    }
}